import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const Icons = {
  ChevronRight: () => <UIcons.UilArrowRight className="" />,
  LeftArrow: () => <UIcons.UilArrowLeft className="" />,
  Export: () => <UIcons.UilExport className="" />,
  Clear: () => <UIcons.UilTimes className=""  />,
  Delete: () => <UIcons.UilTrash className="" />,
  Filter: () => <UIcons.UilFilter className=""  />,
  FirstPage: () => <UIcons.UilAngleDoubleLeft className=""  />,
  LastPage: () => <UIcons.UilAngleDoubleRight className=""  />,
  NextPage: () => <UIcons.UilAngleRight className=""  />,
  PreviousPage: () => <UIcons.UilAngleLeft className=""  />,
  ResetSearch: () => <UIcons.UilTimes className=""  />,
  Search: () => <UIcons.UilSearch className=""  />,
  SortArrow: () => <UIcons.UilSorting className=""  />
}

export default Icons;
